// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CtsGantryFunctionalUnitStepListComponent } from '../cts-gantry-functional-unit-step-list/cts-gantry-functional-unit-step-list.component';
import { formatClassName } from '../../util/cts-gantry-util';
import { CtsGantryGridHighlightDirective } from '../../directives/cts-gantry-grid-highlight.directive';
import { CtsGantryFunctionalUnitStep } from '../../interfaces/cts-gantry-functional-unit-step';
import { TranslateModule } from '@ngx-translate/core';
import { CtsGantryFunctionalUnitCheck } from '../../interfaces/cts-gantry-functional-unit-check';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    CtsGantryFunctionalUnitStepListComponent,
    CtsGantryGridHighlightDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-functional-unit-grid',
  templateUrl: './cts-gantry-functional-unit-grid.component.html',
  styleUrl: './cts-gantry-functional-unit-grid.component.scss',
})
export class CtsGantryFunctionalUnitGridComponent {
  @Input({ required: true })
  functionalUnitList: CtsGantryFunctionalUnitCheck[] = [];
  @Input({ required: true }) stepsDefinition: CtsGantryFunctionalUnitStep[] =
    [];

  protected formatClassName(name: string): string {
    return formatClassName(name);
  }
}
